<template>
    <div class="card mb-5">
        <div class="card-title">
            <span>Продажа – #{{ order.id }}</span>
        </div>

        <div class="flex -mx-2">
            <text-field 
                class="w-1/2 px-2"
                title="Счет"
                v-bind:value="order.amount"
                disabled />

            <text-field 
                class="w-1/2 px-2"
                title="Клиент"
                v-bind:value="order.customer.name"
                disabled />
        </div>

        <div class="flex -mx-2">
            <text-field 
                class="w-1/2 px-2"
                title="Стоимость"
                v-bind:value="order.amount"
                disabled />

            <text-field 
                class="w-1/2 px-2"
                title="Дата продажи"
                v-bind:value="localTime(order.customer.sold_at)"
                disabled />
        </div>

        <textarea-field
            title="Комментарий"
            v-model="order.comment"
            disabled />
    </div>
</template>

<script>
    export default {
        props: {
            order: Object,
        }
    }
</script>